<script>

/**
 * Input component
 */
export default {

  props: {
    type: {
      type: String,
      default: 'text'
    },
    text: {
      type: String,
      default: 'This value is required.',
    }
  },
};
</script>
<template>
  <div class="invalid-feedback" style="margin-top: -10px; margin-bottom: 10px;">
    <span>{{this.type == 'text' ? `${$t('general.please-enter')} ${this.text}` : `${$t('general.please-select')} ${this.text}`}}</span>
  </div>
</template>